import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { format, parseISO } from "date-fns";
import ReportDatePicker from "../ReportDatePicker/ReportDatePicker";
import "./Calendar.scss";

const Calendar = ({
  handleSubmit,
  dateValueObj,
  isDisabled,
  setSelectedDates,
  selectedDates,
}) => {
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const formatDates = (date) => {
    if (!date) return null;
    return format(parseISO(date), "yyyy-MM-dd");
  };

  return (
    <Dropdown
      isOpen={openDatePicker}
      toggle={() => setOpenDatePicker(!openDatePicker)}
    >
      <DropdownToggle tag="div" className="report-date-preview">
        <div>
          {!dateValueObj?.value &&
          !dateValueObj?.value2 &&
          !selectedDates?.value &&
          !selectedDates?.value2 ? (
            <span className="me-2 custom-dr-placeholder">
              Select Custom Date Range
            </span>
          ) : (
            <span className="me-2 custom-dr-placeholder">
              {formatDates(dateValueObj?.value || selectedDates?.value)} to{" "}
              {formatDates(dateValueObj?.value2 || selectedDates?.value2)}
            </span>
          )}
          <span className="mdi mdi-calendar-month-outline"></span>
        </div>
      </DropdownToggle>
      <DropdownMenu className="calendar-dropdown-menu">
        <ReportDatePicker
          setOpenDatePicker={setOpenDatePicker}
          onDateRange={handleSubmit}
          dateValueObj={dateValueObj}
          selectedDatesMain={selectedDates}
          setSelectedDatesMain={setSelectedDates}
        />
      </DropdownMenu>
    </Dropdown>
  );
};

export default Calendar;
